import {getFormatText, getReverseDate} from "@/scripts/formatDate";
import {ProtocolLineParent} from "@/models/ProtocolLine";

export class ProtocolParent {
  constructor() {
    this.list = []
  }

  addProtocol(item) {

    const body = item
    body.protocolDate = getReverseDate(body.protocolDate)

    this.list.push(Protocol.buildFromAPI(body))
  }

  updateProtocol(item) {
    const index = this.list.findIndex(el => el.id === item.id)

    const body = item
    body.protocolDate = getReverseDate(body.protocolDate)

    this.list.splice(index, 1, Protocol.buildFromAPI(body))
  }

  removeProtocol(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => Protocol.buildFromAPI(el))
    }
    return this
  }
}

export class Protocol {
  constructor() {
    this.id = null
    this.protocolNumber = null
    this.protocolDate = null
    this.protocolLineList = new ProtocolLineParent()
  }

  get protocolDateText () {
    return this.protocolDate && getFormatText(this.protocolDate)
  }

  getForAPI() {
    return {
      id: this.id,
      protocolNumber: this.protocolNumber,
      protocolDate: getReverseDate(this.protocolDate),
      protocolLineList: []
    }
  }

  static buildFromAPI(obj) {
    const _this = new Protocol()
    if (obj) {
      _this.id = obj.id
      _this.protocolNumber = obj.protocolNumber
      _this.protocolDate = obj.protocolDate
      obj && obj.protocolLineList.forEach(el => _this.protocolLineList.addProtocolLine(el))
    }
    return _this
  }
}